export default __webpack_public_path__ + "static/media/spade-img.16ca6de3.webp";